/** Разблокировка HTMLAudio для «слушать вместе» (autoplay policy). */

let unlocked = false;
const pending = new Set<() => void>();
const arming = new WeakSet<HTMLAudioElement>();

function armElement(audio: HTMLAudioElement): Promise<void> {
  if (!audio.paused && !audio.muted) return Promise.resolve();
  arming.add(audio);
  const wasMuted = audio.muted;
  const wasTime = audio.currentTime;
  audio.muted = true;
  return audio
    .play()
    .then(() => {
      audio.pause();
      audio.muted = wasMuted;
      try {
        if (Number.isFinite(wasTime)) audio.currentTime = wasTime;
      } catch {
        /* ignore */
      }
    })
    .catch(() => {
      audio.muted = wasMuted;
    })
    .finally(() => {
      arming.delete(audio);
    });
}

export function isArmingBoardAudio(audio: HTMLAudioElement): boolean {
  return arming.has(audio);
}

/** Вызвать из жеста пользователя (клик по доске / галочка / play). */
export function unlockBoardAudio(): void {
  const firstUnlock = !unlocked;
  unlocked = true;
  const runPending = () => {
    const fns = [...pending];
    pending.clear();
    for (const fn of fns) {
      try {
        fn();
      } catch {
        /* ignore */
      }
    }
  };
  if (!firstUnlock) {
    runPending();
    return;
  }
  const players = document.querySelectorAll("audio.wb-audio-card__player");
  const jobs: Promise<void>[] = [];
  players.forEach((el) => {
    if (el instanceof HTMLAudioElement) jobs.push(armElement(el));
  });
  if (jobs.length) {
    void Promise.all(jobs).finally(runPending);
  } else {
    runPending();
  }
}

export function isBoardAudioUnlocked(): boolean {
  return unlocked;
}

/** Если уже unlocked — сразу; иначе после следующего жеста. */
export function whenBoardAudioUnlocked(fn: () => void): void {
  if (unlocked) {
    fn();
    return;
  }
  pending.add(fn);
}

/** Новый <audio> после разблокировки — сразу вооружить. */
export function armBoardAudioElement(audio: HTMLAudioElement): void {
  if (!unlocked) return;
  void armElement(audio);
}

/** Слушатели жеста на корне доски. */
export function installBoardAudioUnlock(root: HTMLElement): () => void {
  const onGesture = () => unlockBoardAudio();
  root.addEventListener("pointerdown", onGesture, true);
  root.addEventListener("keydown", onGesture, true);
  return () => {
    root.removeEventListener("pointerdown", onGesture, true);
    root.removeEventListener("keydown", onGesture, true);
  };
}
